module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAS1BMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uR0tFsOAAAAGHRSTlMAiZ+TQqo63k19GhNUDNWcYerl8Cxr/DCcuQq2AAAAmUlEQVQY031QSxbDIAjEXzRqNE3ayv1PWgXzdJFmFsIMI4LA8L6d2wYDPiPuABFRhEtz2GAtBd3FFSd8hnNgeXDuRA6lXpS4Kgk2KC3lkjlfgctWU7+DCXBRSLIrZl3Mgu4ZIl9IrBaLmArnCbTkx7VeHPU/cxs1WJyQ+qfEWYx3a7q7NdcuBtMmjvtZgwxwoRhR+3tj3vAXP0J5FbnqqLCIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_account_settings.png
// module id = bl2V
// module chunks = 15